<template>
    <div class="admin-paper-import-dashboard animation-fadeIn">
        <!-- Page Header -->
        <div class="page-header">
            <div class="header-info">
                <h2 class="page-title">试卷批量导入</h2>
                <p class="page-subtitle">支持 Word 文档解析，支持公式、图片自动处理，极大提升录题效率</p>
            </div>
            <div class="header-actions">
                <el-button @click="$router.back()">
                    <el-icon>
                        <ArrowLeft />
                    </el-icon> 返回
                </el-button>
            </div>
        </div>

        <div class="import-layout">
            <el-row :gutter="24">
                <!-- Settings Column -->
                <el-col :span="24">
                    <div class="settings-container">
                        <el-card shadow="never" class="modern-card settings-card">
                            <template #header>
                                <div class="card-header">
                                    <span class="card-title"><el-icon>
                                            <Document />
                                        </el-icon> 试卷基础信息</span>
                                </div>
                            </template>

                            <el-form :model="paperForm" label-position="top" class="modern-form">
                                <el-form-item label="试卷名称" required>
                                    <el-input v-model="paperForm.name" placeholder="请输入完整试卷名称" />
                                </el-form-item>

                                <el-row :gutter="12">
                                    <el-col :span="12">
                                        <el-form-item label="试卷类型" required>
                                            <el-select v-model="paperForm.category" style="width: 100%">
                                                <el-option label="同步卷" value="同步卷" />
                                                <el-option label="月考卷" value="月考卷" />
                                                <el-option label="期中卷" value="期中卷" />
                                                <el-option label="期末卷" value="期末卷" />
                                                <el-option label="模拟卷" value="模拟卷" />
                                                <el-option label="真题卷" value="真题卷" />
                                                <el-option label="强基计划" value="强基计划" />
                                                <el-option label="讲义课件" value="讲义课件" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="年份">
                                            <el-input v-model="paperForm.year" placeholder="2024" />
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row :gutter="12">
                                    <el-col :span="12">
                                        <el-form-item label="年级">
                                            <el-select v-model="paperForm.grade" style="width: 100%">
                                                <el-option label="高一" value="高一" />
                                                <el-option label="高二" value="高二" />
                                                <el-option label="高三" value="高三" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="学期">
                                            <el-select v-model="paperForm.semester" style="width: 100%">
                                                <el-option label="上学期" value="上学期" />
                                                <el-option label="下学期" value="下学期" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row :gutter="12">
                                    <el-col :span="12">
                                        <el-form-item label="难度">
                                            <el-select v-model="paperForm.difficulty" style="width: 100%">
                                                <el-option label="容易" value="容易" />
                                                <el-option label="较易" value="较易" />
                                                <el-option label="适中" value="适中" />
                                                <el-option label="较难" value="较难" />
                                                <el-option label="困难" value="困难" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="地区">
                                            <el-cascader v-model="paperForm.area" :options="pcTextArr"
                                                placeholder="选择地区" style="width: 100%" clearable />
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row :gutter="12">
                                    <el-col :span="12">
                                        <el-form-item label="教材版本">
                                            <el-select v-model="paperForm.textbookVersionId" style="width: 100%"
                                                @change="handleVersionChange" placeholder="选择版本">
                                                <el-option v-for="v in textbookVersions" :key="v.id" :label="v.name"
                                                    :value="v.id" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="教材">
                                            <el-select v-model="paperForm.textbookId" style="width: 100%"
                                                placeholder="选择教材">
                                                <el-option v-for="t in filteredTextbooks" :key="t.id" :label="t.name"
                                                    :value="t.id" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-form-item label="来源 (学校/单位)">
                                    <el-input v-model="paperForm.source" placeholder="例如：某中学" />
                                </el-form-item>
                            </el-form>
                        </el-card>

                        <el-card shadow="never" class="modern-card upload-card" style="margin-top: 24px">
                            <template #header>
                                <div class="card-header">
                                    <span class="card-title"><el-icon>
                                            <Upload />
                                        </el-icon> 文件上传与解析</span>
                                </div>
                            </template>

                            <div class="upload-zone">
                                <label class="custom-file-upload">
                                    <input type="file" ref="fileInput" accept=".docx" @change="handleFileChange" />
                                    <div class="upload-placeholder" v-if="!importForm.file">
                                        <el-icon class="upload-icon">
                                            <UploadFilled />
                                        </el-icon>
                                        <span>点击选择 Word 文档 (.docx)</span>
                                    </div>
                                    <div class="file-selected" v-else>
                                        <el-icon class="file-icon">
                                            <Document />
                                        </el-icon>
                                        <span>{{ importForm.file.name }}</span>
                                    </div>
                                </label>
                            </div>

                            <div class="parsing-options">
                                <div class="option-item">
                                    <span class="option-label">答案位置</span>
                                    <el-radio-group v-model="importForm.answerFormat">
                                        <el-radio label="end">试卷末尾</el-radio>
                                        <el-radio label="inline">每题后面</el-radio>
                                    </el-radio-group>
                                </div>
                            </div>


                            <!-- Markdown Preview Section -->
                            <div class="markdown-preview-section" v-if="markdownContent">
                                <el-collapse>
                                    <el-collapse-item title="查看解析后的 Markdown 原文" name="1">
                                        <div class="markdown-content-box">
                                            <el-input v-model="markdownContent" type="textarea" :rows="10" readonly
                                                resize="none" />
                                            <div class="markdown-actions">
                                                <el-button type="primary" link @click="copyMarkdown">
                                                    <el-icon>
                                                        <CopyDocument />
                                                    </el-icon> 复制全文
                                                </el-button>
                                            </div>
                                        </div>
                                    </el-collapse-item>
                                </el-collapse>
                            </div>

                            <div class="ai-toggle-row">
                                <el-switch v-model="enableAI" active-text="开启 AI 知识点分析" inactive-text="关闭"
                                    active-color="#409eff" />
                                <span class="ai-hint" v-if="enableAI">⚠️ 开启后解析较慢（逐题 DeepSeek）</span>
                                <span class="ai-hint safe" v-else>✅ 关闭 AI，解析快速不超时</span>
                            </div>

                            <div class="action-bar">
                                <el-button type="primary" size="large" @click="startParsing" :loading="parsing" block
                                    class="parse-btn">
                                    <el-icon v-if="!parsing">
                                        <MagicStick />
                                    </el-icon>
                                    {{ parsing ? '正在智能解析中...' : '智能解析 Word' }}
                                </el-button>
                            </div>
                        </el-card>
                    </div>
                </el-col>

                <!-- Preview Column -->
                <el-col :span="24" style="margin-top: 24px;">
                    <el-card shadow="never" class="modern-card preview-card">
                        <template #header>
                            <div class="card-header">
                                <div class="header-left">
                                    <span class="card-title"><el-icon>
                                            <View />
                                        </el-icon> 解析结果预览</span>
                                    <el-tag v-if="questions.length > 0" type="success" effect="dark" round
                                        style="margin-left: 12px">找到 {{ questions.length }} 题</el-tag>
                                </div>
                                <el-button type="success" v-if="questions.length > 0" @click="saveAll" :loading="saving"
                                    class="confirm-btn">
                                    <el-icon>
                                        <CircleCheck />
                                    </el-icon> 确认并提交导入
                                </el-button>
                            </div>
                        </template>

                        <div class="preview-scroll-area">
                            <el-empty v-if="questions.length === 0" description="暂无解析结果，请在左侧上传文档并解析" />

                            <div v-else class="question-stream">
                                <div v-for="(q, index) in questions" :key="index" class="question-paper-card">
                                    <div class="q-card-header">
                                        <div class="q-badge">第 {{ index + 1 }} 题</div>
                                        <div class="q-controls">
                                            <el-select v-model="q.type" size="small" style="width: 100px">
                                                <el-option label="单选题" :value="1" />
                                                <el-option label="填空题" :value="2" />
                                                <el-option label="解答题" :value="3" />
                                                <el-option label="证明题" :value="4" />
                                                <el-option label="应用题" :value="5" />
                                                <el-option label="多选题" :value="6" />
                                            </el-select>
                                            <el-select v-model="q.difficult" size="small" style="width: 80px"
                                                placeholder="难度">
                                                <el-option label="容易" :value="1" />
                                                <el-option label="较易" :value="2" />
                                                <el-option label="适中" :value="3" />
                                                <el-option label="较难" :value="4" />
                                                <el-option label="困难" :value="5" />
                                            </el-select>
                                            <div class="score-input">
                                                <el-input-number v-model="q.score" size="small" :min="0" :max="50"
                                                    controls-position="right" style="width: 80px" />
                                                <span class="unit">分</span>
                                            </div>
                                            <el-cascader v-model="q.area" :options="pcTextArr" placeholder="地区"
                                                size="small" style="width: 140px" clearable />
                                            <el-input v-model="q.source" size="small" placeholder="来源"
                                                style="width: 140px" />
                                            <el-button type="danger" link size="small" @click="removeQuestion(index)">
                                                <el-icon>
                                                    <Delete />
                                                </el-icon>
                                            </el-button>
                                            <el-button type="primary" link size="small" @click="analyzeKP(index)"
                                                :loading="q.analyzingKP"
                                                title="使用 DeepSeek AI 分析本题知识点">
                                                <el-icon v-if="!q.analyzingKP"><Connection /></el-icon>
                                                {{ q.analyzingKP ? '分析中...' : 'AI 知识点' }}
                                            </el-button>
                                        </div>
                                    </div>

                                    <div class="q-card-body">
                                        <div class="field-block">
                                            <div class="field-label">题干内容</div>
                                            <MdEditor v-model="q.content" preview-theme="cyanosis"
                                                class="auto-expand-editor" style="min-height: 240px;" />
                                        </div>

                                        <div class="field-block" v-if="q.options && q.options.length > 0">
                                            <div class="field-label">选择选项</div>
                                            <div class="options-edit-grid">
                                                <div v-for="(opt, i) in q.options" :key="i" class="option-edit-row">
                                                    <span class="opt-id">{{ opt.Label }}.</span>
                                                    <el-input v-model="opt.Content" size="small" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="field-block">
                                            <div class="field-label">正确答案</div>
                                            <MdEditor v-model="q.answer" preview-theme="cyanosis"
                                                class="auto-expand-editor" style="min-height: 120px;" />
                                        </div>

                                        <div class="field-block">
                                            <div class="field-label">分析</div>
                                            <MdEditor v-model="q.analysis" preview-theme="cyanosis"
                                                class="auto-expand-editor" style="min-height: 120px;" />
                                        </div>

                                        <div class="field-block">
                                            <div class="field-label">详解</div>
                                            <MdEditor v-model="q.explanation" preview-theme="cyanosis"
                                                class="auto-expand-editor" style="min-height: 180px;" />
                                        </div>

                                        <div class="field-block">
                                            <div class="field-label">点睛</div>
                                            <MdEditor v-model="q.keyPoints" preview-theme="cyanosis"
                                                class="auto-expand-editor" style="min-height: 120px;" />
                                        </div>

                                        <div class="field-block">
                                            <div class="field-label">关联知识点</div>
                                            <div class="kp-picker-modern">
                                                <el-tag v-for="(kp, kpi) in q.knowledgePoints" :key="kpi" closable
                                                    @close="removeKp(index, kpi)" class="modern-kp-tag">
                                                    {{ kp.name }}
                                                </el-tag>
                                                <el-autocomplete v-model="q.newKpInput"
                                                    :fetch-suggestions="querySearchKp" placeholder="检索并关联知识点..."
                                                    size="small" @select="(item) => handleSelectKp(index, item)"
                                                    style="width: 200px">
                                                    <template #prefix><el-icon>
                                                            <Search />
                                                        </el-icon></template>
                                                </el-autocomplete>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Add Question Button -->
                                    <div class="add-question-bar">
                                        <el-button type="primary" link @click="insertQuestionAfter(index)">
                                            <el-icon>
                                                <Plus />
                                            </el-icon> 在此题后添加题目
                                        </el-button>
                                    </div>
                                </div>
                            </div>

                            <!-- Add question at the end -->
                            <div class="add-question-end" v-if="questions.length > 0">
                                <el-button type="success" @click="addNewQuestion">
                                    <el-icon>
                                        <Plus />
                                    </el-icon> 添加新题目
                                </el-button>
                            </div>
                        </div>
                    </el-card>

                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import {
    ArrowLeft, Document, Upload, UploadFilled, MagicStick,
    View, CircleCheck, Delete, Search, CollectionTag, Plus, CopyDocument, Connection
} from '@element-plus/icons-vue'
import api, { getTextbookVersions } from '@/utils/api'
import { pcTextArr } from 'element-china-area-data'
import MdEditor from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';

const router = useRouter()
const parsing = ref(false)
const saving = ref(false)
const questions = ref([])
const markdownContent = ref('') // Store raw markdown
const allKnowledgePoints = ref([])
const textbookVersions = ref([])
const textbooks = ref([])
const enableAI = ref(false)

const paperForm = reactive({
    name: '',
    description: '',
    category: '期中卷',
    region: '',
    city: '',
    year: new Date().getFullYear().toString(),
    semester: '上学期',
    grade: '高一',
    difficulty: '适中',
    textbookVersionId: null,
    textbookId: null,
    source: '',
    area: []
})

const importForm = reactive({
    file: null,
    answerFormat: 'end'
})

const handleFileChange = (e) => {
    const files = e.target.files
    if (files.length > 0) {
        importForm.file = files[0]
    }
}

const fetchKnowledgePoints = async () => {
    try {
        const res = await api.get('/api/knowledgePoints')
        allKnowledgePoints.value = res.data.knowledgePoints || res.data || []
    } catch (err) {
        console.error('Failed to load KPs', err)
    }
}

const fetchTextbookVersions = async () => {
    try {
        const res = await getTextbookVersions()
        textbookVersions.value = res.data.versions || res.data || []
    } catch (err) {
        console.error('Failed to load textbook versions', err)
    }
}

const fetchTextbooks = async () => {
    try {
        const res = await api.get('/api/textbooks')
        textbooks.value = res.data.textbooks || res.data || []
    } catch (err) {
        console.error('Failed to load textbooks', err)
    }
}

// Filter textbooks based on selected textbook version
const filteredTextbooks = computed(() => {
    if (!paperForm.textbookVersionId) return textbooks.value
    return textbooks.value.filter(t => t.textbookVersionId === paperForm.textbookVersionId)
})

// Handle textbook version change - reset textbook selection
const handleVersionChange = () => {
    paperForm.textbookId = null
}

const querySearchKp = (queryString, cb) => {
    const results = queryString
        ? allKnowledgePoints.value.filter(kp => kp.name.toLowerCase().includes(queryString.toLowerCase()))
        : allKnowledgePoints.value
    cb(results.map(kp => ({ value: kp.name, id: kp.id })))
}

const handleSelectKp = (qIndex, item) => {
    const q = questions.value[qIndex]
    if (!q.knowledgePoints.some(kp => kp.id === item.id)) {
        q.knowledgePoints.push({ id: item.id, name: item.value })
    }
    q.newKpInput = ''
}

const removeKp = (qIndex, kpIndex) => {
    questions.value[qIndex].knowledgePoints.splice(kpIndex, 1)
}

const removeQuestion = (index) => {
    questions.value.splice(index, 1)
}

// Create empty question template
const createEmptyQuestion = (questionNumber = 1) => ({
    content: '',
    type: 3, // 解答题
    typeName: '解答题',
    answer: '',
    analysis: '',
    explanation: '',
    keyPoints: '',
    options: [],
    newKpInput: '',
    knowledgePoints: [],
    score: 0,
    questionNumber: questionNumber
})

// Add new question at the end
const addNewQuestion = () => {
    const newNum = questions.value.length > 0
        ? Math.max(...questions.value.map(q => q.questionNumber || 0)) + 1
        : 1
    questions.value.push(createEmptyQuestion(newNum))
    ElMessage.success(`已添加第 ${newNum} 题`)
}

// Insert question after specific index
const insertQuestionAfter = (index) => {
    const newNum = (questions.value[index]?.questionNumber || index) + 1
    questions.value.splice(index + 1, 0, createEmptyQuestion(newNum))
    // Renumber subsequent questions
    for (let i = index + 2; i < questions.value.length; i++) {
        questions.value[i].questionNumber = (questions.value[i - 1]?.questionNumber || i) + 1
    }
    ElMessage.success(`已在第 ${index + 1} 题后插入新题`)
}


const startParsing = async () => {
    if (!importForm.file) {
        ElMessage.warning('请选择文件')
        return
    }

    parsing.value = true
    const formData = new FormData()
    formData.append('file', importForm.file)
    formData.append('answer_format', importForm.answerFormat)
    formData.append('enable_ai', enableAI.value ? 'true' : 'false')

    try {
        const res = await api.post('/api/papers/import', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 180000
        })

        if (res.data.success) {
            questions.value = res.data.questions.map(q => ({
                ...q,
                newKpInput: '',
                knowledgePoints: q.knowledgePoints || [],
                analysis: q.analysis || '',
                keyPoints: q.keyPoints || '',
                source: q.source || paperForm.source || paperForm.name,
                area: [...(paperForm.area || [])],
                score: 0,
                analyzingKP: false
            }))
            markdownContent.value = res.data.markdown_content || ''
            ElMessage.success(`解析成功，共 ${res.data.questions.length} 道题目`)

        } else {
            ElMessage.error(res.data.message || '解析失败')
        }
    } catch (error) {
        console.error(error)
        if (error?.code === 'ECONNABORTED') {
            ElMessage.error('解析超时，请稍后重试（可减少一次导入的页数）')
        } else {
            ElMessage.error('解析请求失败')
        }
    } finally {
        parsing.value = false
    }
}

const copyMarkdown = async () => {
    try {
        await navigator.clipboard.writeText(markdownContent.value)
        ElMessage.success('Markdown 内容已复制')
    } catch (err) {
        ElMessage.error('复制失败')
    }
}

const saveAll = async () => {
    if (questions.value.length === 0) return

    if (!paperForm.name) {
        ElMessage.warning('请填写试卷名称')
        return
    }

    saving.value = true
    try {
        // Prepare region/city from cascader
        const region = paperForm.area?.[0] || ''
        const city = paperForm.area?.[1] || ''

        // Prepare questions data
        const questionsToSave = questions.value.map(q => ({
            ...q,
            region: q.area?.[0] || '',
            city: q.area?.[1] || '',
            knowledgePoints: q.knowledgePoints
        }))

        const res = await api.post('/api/papers/import/confirm', {
            name: paperForm.name,
            description: paperForm.description,
            category: paperForm.category,
            region: region,
            city: city,
            year: paperForm.year,
            semester: paperForm.semester,
            grade: paperForm.grade,
            difficulty: paperForm.difficulty,
            textbookVersionId: paperForm.textbookVersionId,
            textbookId: paperForm.textbookId,
            source: paperForm.source,
            questions: questionsToSave
        })

        if (res.data.success) {
            ElMessage.success(`成功导入试卷，包含 ${res.data.count} 道题目`)
            questions.value = []
            router.push('/admin/paper-list')
        } else {
            ElMessage.error(res.data.message || '保存失败')
        }
    } catch (error) {
        console.error(error)
        ElMessage.error('保存请求失败')
    } finally {
        saving.value = false
    }
}

onMounted(() => {
    fetchKnowledgePoints()
    fetchTextbookVersions()
    fetchTextbooks()
})

// Per-question AI knowledge point analysis
const analyzeKP = async (index) => {
    const q = questions.value[index]
    if (!q || !q.content) {
        ElMessage.warning('该题目内容为空')
        return
    }
    q.analyzingKP = true
    try {
        const res = await api.post('/api/questions/analyze-kp', {
            content: q.content
        })
        if (res.data.success && res.data.knowledgePoints && res.data.knowledgePoints.length > 0) {
            const existingNames = new Set(q.knowledgePoints.map(k => k.name))
            res.data.knowledgePoints.forEach(kp => {
                if (!existingNames.has(kp.name)) {
                    q.knowledgePoints.push(kp)
                    existingNames.add(kp.name)
                }
            })
            ElMessage.success(`AI 识别出 ${res.data.knowledgePoints.length} 个知识点`)
        } else {
            ElMessage.info('AI 未识别到相关知识点')
        }
    } catch (err) {
        console.error(err)
        ElMessage.error('AI 分析失败，请检查 DeepSeek 配置')
    } finally {
        q.analyzingKP = false
    }
}
</script>

<style scoped>
.admin-paper-import-dashboard {
    background-color: transparent;
}

.settings-container {
    margin-bottom: 24px;
}

.page-header {
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #1a1a1a;
}

.page-subtitle {
    margin: 4px 0 0;
    color: #606266;
    font-size: 14px;
}

.modern-card {
    border: none;
    border-radius: 12px;
}

.card-title {
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
}

.modern-form :deep(.el-form-item__label) {
    font-weight: 600;
    padding-bottom: 4px;
}

.upload-zone {
    border: 2px dashed #dcdfe6;
    border-radius: 12px;
    padding: 30px;
    text-align: center;
    transition: all 0.3s;
    background: #f8fafc;
}

.upload-zone:hover {
    border-color: #409eff;
    background: #ecf5ff;
}

.custom-file-upload {
    cursor: pointer;
    display: block;
}

.custom-file-upload input[type="file"] {
    display: none;
}

.upload-icon {
    font-size: 40px;
    color: #909399;
    margin-bottom: 12px;
}

.upload-placeholder span {
    display: block;
    color: #606266;
}

.file-selected {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #409eff;
}

.file-icon {
    font-size: 40px;
    margin-bottom: 12px;
}

.ai-toggle-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    padding: 10px 14px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e4e7ed;
}

.ai-hint {
    font-size: 13px;
    color: #e6a23c;
}

.ai-hint.safe {
    color: #67c23a;
}

.parsing-options {
    margin: 20px 0;
    padding: 15px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
}

.option-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.option-label {
    font-weight: 600;
    color: #606266;
}

.parse-btn {
    width: 100%;
}

.preview-card {
    display: flex;
    flex-direction: column;
}

.preview-scroll-area {
    padding: 2px;
}

.question-stream {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.question-paper-card {
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.2s;
}

.question-paper-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #409eff;
}

.q-card-header {
    background: #f8fafc;
    padding: 12px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
}

.q-badge {
    background: #409eff;
    color: white;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: bold;
}

.q-controls {
    display: flex;
    align-items: center;
    gap: 15px;
}

.score-input {
    display: flex;
    align-items: center;
    gap: 6px;
}

.score-input .unit {
    font-size: 13px;
    color: #909399;
}

.q-card-body {
    padding: 20px;
}

.field-block {
    margin-bottom: 20px;
}

.field-block:last-child {
    margin-bottom: 0;
}

.field-label {
    font-size: 13px;
    font-weight: 600;
    color: #909399;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.options-edit-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    background: #f8fafc;
    padding: 15px;
    border-radius: 8px;
}

.option-edit-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.opt-id {
    font-weight: bold;
    color: #409eff;
    width: 20px;
}

.field-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 20px;
}

.kp-picker-modern {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    background: #f8fafc;
    padding: 10px;
    border-radius: 8px;
}

.modern-kp-tag {
    border-radius: 6px;
    height: 28px;
}

.animation-fadeIn {
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.add-question-bar {
    padding: 10px 20px;
    background: #f8fafc;
    border-top: 1px dashed #e4e7ed;
    text-align: center;
}

.add-question-end {
    margin-top: 20px;
    padding: 20px;
    text-align: center;
    background: #f8fafc;
    border-radius: 12px;
    border: 2px dashed #dcdfe6;
}

.markdown-preview-section {
    margin: 20px 0;
    border: 1px solid #ebeef5;
    border-radius: 8px;
    overflow: hidden;
}

.markdown-content-box {
    padding: 10px;
}

.markdown-actions {
    margin-top: 10px;
    text-align: right;
}

.auto-expand-editor {
    height: auto !important;
}

.auto-expand-editor :deep(.md-editor-content) {
    height: auto !important;
}
</style>
